import { LANGUAGE_KEYS } from 'config/languageKeys';

import { ParentalControlRating } from 'store/user/reducer.types';

import {
    SETTINGS_PARENTAL_CONTROL_6,
    SETTINGS_PARENTAL_CONTROL_12,
    SETTINGS_PARENTAL_CONTROL_16,
    SETTINGS_PARENTAL_CONTROL_18,
    SETTINGS_PARENTAL_CONTROL_ADULTS_CENSORED,
    SETTINGS_PARENTAL_CONTROL_ADULTS_UNCENSORED,
} from 'screens/Settings/languagesConst';

const {
    PROFILE: {
        PROFILE_AGE_RATING_DROPDOWN_0_5,
        PROFILE_AGE_RATING_DROPDOWN_6_11,
        PROFILE_AGE_RATING_DROPDOWN_12_MORE,
    },
} = LANGUAGE_KEYS;

export const adultProfileRating = [
    {
        label: SETTINGS_PARENTAL_CONTROL_6,
        key: ParentalControlRating.HU6,
        isSelected: false,
    },
    {
        label: SETTINGS_PARENTAL_CONTROL_12,
        key: ParentalControlRating.HU12,
        isSelected: false,
    },
    {
        label: SETTINGS_PARENTAL_CONTROL_16,
        key: ParentalControlRating.HU16,
        isSelected: false,
    },
    {
        label: SETTINGS_PARENTAL_CONTROL_18,
        key: ParentalControlRating.HU18,
        isSelected: false,
    },
    {
        label: SETTINGS_PARENTAL_CONTROL_ADULTS_CENSORED,
        key: ParentalControlRating.HU18_ADULT_CENSORED,
        isSelected: true,
    },
    {
        label: SETTINGS_PARENTAL_CONTROL_ADULTS_UNCENSORED,
        key: ParentalControlRating.HU18_ADULT_UNCENSORED,
        isSelected: false,
    },
];

export const kidProfileRating = [
    {
        label: PROFILE_AGE_RATING_DROPDOWN_0_5,
        key: ParentalControlRating.HU_GENERAL,
        isSelected: false,
    },
    {
        label: PROFILE_AGE_RATING_DROPDOWN_6_11,
        key: ParentalControlRating.HU6,
        isSelected: false,
    },
    {
        label: PROFILE_AGE_RATING_DROPDOWN_12_MORE,
        key: ParentalControlRating.HU12,
        isSelected: true,
    },
];
